import React from 'react';
import ReactModal from 'react-modal';
import { Content, Header, ModalStyle, OverlayStyle, Text } from './SupportModal.styles';
import { Text22Bold } from '../../utils/Text/Text.styles';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';

const SupportModal = ({ show, setShow }) => {
  return (
    <ReactModal
      isOpen={show}
      closeTimeoutMS={300}
      onRequestClose={() => setShow(false)}
      className="_"
      overlayClassName="_"
      contentElement={props => (
        <ModalStyle {...props}>
          <Header>
            <Text22Bold>Support</Text22Bold>
            <CloseIcon onClick={() => setShow(false)} />
          </Header>
          <Content>
            <Text>Our support team is available via Intercom, feel free to reach out.</Text>
          </Content>
        </ModalStyle>
      )}
      overlayElement={(props, contentElement) => <OverlayStyle {...props}>{contentElement}</OverlayStyle>}
      shouldCloseOnEsc={false}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
    />
  );
};

export default SupportModal;
